function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { Field } from "react-final-form";
import { FormControl, FormHelperText, FormLabel, Input } from "@mui/material";
export default function FileField(_param) {
    var name = _param.name, label = _param.label, fullWidth = _param.fullWidth, validate = _param.validate, extra = _object_without_properties(_param, [
        "name",
        "label",
        "fullWidth",
        "validate"
    ]);
    return /*#__PURE__*/ _jsx(Field, {
        name: name,
        type: "file",
        validate: validate,
        children: function(_param) /*#__PURE__*/ {
            var _param_input = _param.input, value = _param_input.value, onChange = _param_input.onChange, meta = _param.meta, input = _object_without_properties(_param.input, [
                "value",
                "onChange"
            ]);
            return _jsxs(FormControl, {
                component: "fieldset",
                fullWidth: fullWidth,
                children: [
                    /*#__PURE__*/ _jsx(FormLabel, {
                        component: "legend",
                        children: label
                    }),
                    /*#__PURE__*/ _jsx(Input, _object_spread_props(_object_spread({}, extra, input), {
                        type: "file",
                        onChange: function(param) {
                            var target = param.target;
                            var _target_files;
                            return onChange((_target_files = target.files) === null || _target_files === void 0 ? void 0 : _target_files[0]);
                        },
                        error: !!(meta.touched && meta.error)
                    })),
                    /*#__PURE__*/ _jsx(FormHelperText, {
                        error: true,
                        children: meta.touched && meta.error ? meta.error : ""
                    })
                ]
            });
        }
    });
}
